<mat-table [dataSource]="dataSource" #table matSort (matSortChange)="handleSortChange($event)">

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button type="button" class="source-main-button" (click)="openSourceDetails(row)">
          <div class="d-flex flex-col source-copy">
            <span class="source-name">{{ row.name }}</span>
            @if (row.references) {
              <span class="reference">{{ row.references }}</span>
            }
          </div>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button
          type="button"
          class="status-chip"
          [class.status-active]="row.status === allowedStatuses.ACTIVE && !row.isProcessing"
          [class.status-inactive]="row.status === allowedStatuses.INACTIVE && !row.isProcessing"
          [class.status-processing]="row.isProcessing"
          [disabled]="row.isProcessing"
          (click)="toggleStatus(row); $event.stopPropagation()"
          [attr.aria-label]="'Toggle status, currently ' + row.status"
        >
          <span class="status-dot"></span>
          {{ row.isProcessing ? 'Wait...' : (row.status | titlecase) }}
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="processingStatus">
      <mat-header-cell *matHeaderCellDef>Processing</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
        <app-processing-status-indicator
          [sourceId]="row._id"
          [showProgressBar]="true"
          [showLabel]="true"
          [compact]="true"
        ></app-processing-status-indicator>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="updatedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Modified</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="date-text">{{ row.modifiedDate | date: 'd MMM y' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div class="row-actions" (click)="$event.stopPropagation()">
          <app-add-to-list-button [source]="row" [compact]="true"></app-add-to-list-button>
          <button
            mat-icon-button
            type="button"
            class="row-menu-trigger"
            aria-label="Source actions"
            [matMenuTriggerFor]="rowMenu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #rowMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="openSourceDetails(row)">
              <mat-icon>edit</mat-icon>
              <span>Edit source</span>
            </button>
            <button mat-menu-item class="delete-menu-item" (click)="openDeleteSourceModal(row)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="openSourceDetails(row)" class="clickable-row"></mat-row>

  </mat-table>
  <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="paging.total" [pageSize]="paging.limit" [pageSizeOptions]="pageSizes" [pageIndex]="paging.page - 1" aria-label="Select page"></mat-paginator>
